import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import configureStore from "../../store/configureStore";
import {
  document_upload_requested,
  document_upload_errored,
  create_document,
  document_upload_success,
  delete_document_requested,
  delete_document_success,
  delete_document_errored,
} from "../../actions/action-document";
import TextField from "@material-ui/core/TextField";
import Loader from "../../components/common/Loader";
import { showSnackbar } from "../../actions/action-snackbar";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import axios from "axios";

const store = configureStore();

const useStyles = makeStyles({
  Input: {
    fontSize: 14,
  },
  DialogText: {
    fontSize: 16,
  },
  CommentInputWrapper: {
    borderColor: "#dc281e",
    "& .MuiInput-underline": {
      "&:after": {
        borderColor: "#3b4f5a",
      },
    },
  },
  PrimaryButtonroot: {
    background: "#DC281E",
    padding: "5px 15px",
    fontSize: 12,
    "&:hover": {
      background: "#DC281E",
    },
  },
  SecondaryButtonroot: {
    borderColor: "#DC281E",
    marginRight: 15,
    fontSize: 12,
    padding: "5px 15px",
    color: "#DC281E",
    "&:hover": {
      borderColor: "#DC281E",
    },
  },
});

function FormDocumentUploader(props) {
  const { activeOuid, activeOuidChain } = store.getState().permission;
  const { handleUploadChange, data } = props;
  const [file, setFile] = useState();
  const fileInput = React.useRef();
  const [loader, setLoader] = useState(false);
  const classes = useStyles();

  const onFileChange = (event) => {
    console.log("File change", fileInput.current.files[0]);
    console.log("File n change", fileInput.current.files);

    setFile(fileInput.current.files[0]);
    console.log("File onFileChange", file);
  };

  const onFileUpload = async (event) => {
    event.preventDefault();
    setLoader(true);
    console.log(`onFileUpload`, fileInput.current.files[0]);
    await store.dispatch(document_upload_requested());
    console.log("showUploadLoader", store.getState().document.showUploadLoader);
    const { apiEndpoint, credentials } = store.getState().jwt.api;
    if (apiEndpoint && credentials) {
      const fileName = file.name;
      const type = file.type;
      const method = "get";
      const jwt = `${credentials.idToken.jwtToken}`;
      const url = `${apiEndpoint}/document?getUploadSignedUrl=true&file=${fileInput.current.files[0].name}&contentType=${type}`;
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
          "x-ouidchain": activeOuidChain,
        },
      };
      return axios[method](url, axiosHeader)
        .then(async (response) => {
          console.log("signed url get response : ", response.data.uploadURL);
          await uploadFile(response.data.uploadURL);
        })
        .catch((err) => {
          console.log("signed url get failed : ", err);
        });
    }
  };

  const uploadFile = async (signedUrlData) => {
    console.log(`uploadFile`, signedUrlData);
    const { apiEndpoint, credentials } = store.getState().jwt.api;
    if (apiEndpoint && credentials) {
      const method = "put";
      const url = signedUrlData;
      const body = file;
      const axiosHeader = {
        headers: {
          "Content-type": file.type,
        },
      };
      console.log("Url", url);
      return axios[method](url, body, axiosHeader)
        .then(async (response) => {
          console.log("s3 upload response cc : ", response);
          store.dispatch(
            showSnackbar("Document uploaded Successfully", "success")
          );
          console.log("response.config.url", response.config.url.split("?")[0]);
          await store.dispatch(
            document_upload_success(response.config.url.split("?")[0])
          );
          handleUploadChange(response.config.url.split("?")[0], data);
          console.log(
            "showUploadLoader",
            store.getState().document.showUploadLoader
          );
          setLoader(false);
        })
        .catch((err) => {
          store.dispatch(document_upload_errored());
          console.log("s3 upload failed : ", err);
        });
    }
  };

  const { showUploadLoader } = store.getState().document;

  return (
    <div>
      <div>
        {loader ? <Loader /> : ""}
        <div className="form-item-wrapper">
          <label className="image_input_upload_label" for="image_input_upload">
            <h4>Add File</h4>
          </label>
          {file && file.name}
          <input
            id="image_input_upload"
            type="file"
            // accept="image/png, image/jpeg, image/svg"
            onChange={onFileChange}
            ref={fileInput}
          />
        </div>
        <div className="image_upload_btn_wrap">
          <button className="blue_btn" onClick={onFileUpload}>
            Upload
          </button>
        </div>
        {/* {file && (
          <div className="image_upload_btn_wrap">
            <button className="blue_btn" onClick={onFileUpload}>
              Upload
            </button>
          </div>
        )} */}
        {/* <div>
          <Button className="blue_btn" onClick={onFileUpload}>
            Upload
          </Button>
        </div> */}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  document: state.document,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormDocumentUploader);

export const delete_file = (dKey, activeOuid) => async (dispatch) => {
  console.log("in delete_document()");
  dispatch(delete_document_requested());
  const { activeOuidChain } = store.getState().permission;
  console.log(`delete_document`);
  const { apiEndpoint, credentials } = store.getState().jwt.api;
  if (apiEndpoint && credentials) {
    const jwt = `${credentials.idToken.jwtToken}`;
    const url = `${apiEndpoint}/uploads?objectKey=${dKey}`;
    const method = "delete";
    const axiosHeader = {
      headers: {
        Authorization: jwt,
        "x-ouid": activeOuid,
        "x-ouidchain": activeOuidChain,
      },
    };
    return axios[method](url, axiosHeader)
      .then((response) => {
        dispatch(showSnackbar("Document Deleted Successfully", "success"));
        dispatch(delete_document_success());
      })
      .catch((err) => {
        console.log("Document Deletion Failed");
        dispatch(showSnackbar("Document Deletion Failed", "error"));
        dispatch(delete_document_errored(err));
      });
  }
  return null;
};
